<script>
  import { onMount, beforeUpdate, createEventDispatcher } from "svelte";
  import Start from "../components/register/start.svelte";
  import Details from "../components/register/details.svelte";
  import ContactDetails from "../components/register/contactdetails.svelte";
  import Password from "../components/register/password.svelte";
  import AccountConfirmation from "../components/register/accountconfirmation.svelte";
  import SecurityQuestion from "../components/register/SecurityQuestion.svelte";
  import Final from "../components/register/Final.svelte";

  export let step = "start";
  export let username = '';
  let Route = Start;
  const dispatch = createEventDispatcher();

  beforeUpdate(() => {
    switch (step) {
      case "start":
        Route = Start;
        break;
      case "details":
        Route = Details;
        break;
      case "contactdetails":
        Route = ContactDetails;
        break;
      case "password":
        Route = Password;
        break;
      case "accountconfirmation":
        Route = AccountConfirmation;
        break;
      case "securityquestion":
        Route = SecurityQuestion;
        break;
      case "final":
        Route = Final;
        break;
      default:
        Route = Start;
        break;
    }
  });
  
  onMount(() => {
    if (step != "start")
      window.onbeforeunload = function() {
        return "Are you sure you want to leave? By leaving, your registration progress will be lost. ";
      };
  });
</script>

<svelte:head>
  <title>Register | eAdmissions</title>
</svelte:head>

<section class="hero is-fullheight" style="background-color: #407f8a;">
  <div class="hero-body">
    <div class="container">
      <div style="text-align:center;">
        <a
          class=""
          href="/"
          on:click={e => {
            if (step != 'start' && !confirm('Are you sure you want to leave? By leaving, your registration progress will be lost.')) e.preventDefault();
          }}>
          <img
            style="height:40px"
            src="/eamissions-logo.png"
            alt="eAdmissions Logo"  title="Go to home page" />
        </a>
      </div>
      <div class="columns is-centered">
        <div class="column is-7-tablet is-6-desktop is-5-widescreen">
            <svelte:component
              this={Route}
              {username}
              on:pageChange={event => dispatch('pageChange', event.detail)} />
        </div>
      </div>
    </div>
  </div>
</section>
